export default "__VITE_ASSET__CQC1i5ye__"